import React, { createContext, useContext, useState, useEffect } from 'react';
import { detectLanguage, getTranslation } from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first, then detect from browser
    const saved = localStorage.getItem('suco_language');
    return saved || detectLanguage();
  });

  useEffect(() => {
    localStorage.setItem('suco_language', language);
    // Update HTML lang attribute
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => getTranslation(language, key);

  const value = {
    language,
    setLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Language names for selector
export const languageNames = {
  es: 'Español',
  en: 'English',
  pt: 'Português',
  zh: '中文',
  ja: '日本語',
  ar: 'العربية',
  de: 'Deutsch',
  it: 'Italiano',
  fr: 'Français'
};
